import React, { useState } from 'react';
import { SearchIcon, FilterIcon, UserIcon, MailIcon, PhoneIcon, CalendarIcon, CheckCircleIcon, XCircleIcon } from 'lucide-react';
const AdminUserList = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  // Mock user data
  const users = [{
    id: 1,
    name: 'Emma Wilson',
    email: 'emma@example.com',
    phone: '+1 (555) 123-4567',
    dateJoined: 'May 12, 2023',
    status: 'active',
    bookings: 4,
    avatar: 'https://randomuser.me/api/portraits/women/44.jpg'
  }, {
    id: 2,
    name: 'Michael Johnson',
    email: 'michael@example.com',
    phone: '+1 (555) 234-5678',
    dateJoined: 'June 3, 2023',
    status: 'active',
    bookings: 2,
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg'
  }, {
    id: 3,
    name: 'Sophia Martinez',
    email: 'sophia@example.com',
    phone: '+1 (555) 345-6789',
    dateJoined: 'March 21, 2023',
    status: 'inactive',
    bookings: 1,
    avatar: 'https://randomuser.me/api/portraits/women/17.jpg'
  }, {
    id: 4,
    name: 'William Brown',
    email: 'william@example.com',
    phone: '+1 (555) 456-7890',
    dateJoined: 'July 15, 2023',
    status: 'active',
    bookings: 3,
    avatar: 'https://randomuser.me/api/portraits/men/91.jpg'
  }, {
    id: 5,
    name: 'Olivia Davis',
    email: 'olivia@example.com',
    phone: '+1 (555) 567-8901',
    dateJoined: 'April 8, 2023',
    status: 'suspended',
    bookings: 0,
    avatar: 'https://randomuser.me/api/portraits/women/63.jpg'
  }, {
    id: 6,
    name: 'James Miller',
    email: 'james@example.com',
    phone: '+1 (555) 678-9012',
    dateJoined: 'August 29, 2023',
    status: 'active',
    bookings: 1,
    avatar: 'https://randomuser.me/api/portraits/men/67.jpg'
  }, {
    id: 7,
    name: 'Emily Taylor',
    email: 'emily@example.com',
    phone: '+1 (555) 789-0123',
    dateJoined: 'February 14, 2023',
    status: 'active',
    bookings: 6,
    avatar: 'https://randomuser.me/api/portraits/women/33.jpg'
  }, {
    id: 8,
    name: 'Alexander Wilson',
    email: 'alex@example.com',
    phone: '+1 (555) 890-1234',
    dateJoined: 'September 5, 2023',
    status: 'inactive',
    bookings: 0,
    avatar: 'https://randomuser.me/api/portraits/men/4.jpg'
  }];
  // Filter users based on search term and status
  const filteredUsers = users.filter(user => {
    const matchesSearch = user.name.toLowerCase().includes(searchTerm.toLowerCase()) || user.email.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = filterStatus === 'all' || user.status === filterStatus;
    return matchesSearch && matchesStatus;
  });
  const getStatusBadge = status => {
    switch (status) {
      case 'active':
        return <span className="px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800" data-id="element-443">
            Active
          </span>;
      case 'inactive':
        return <span className="px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800" data-id="element-444">
            Inactive
          </span>;
      case 'suspended':
        return <span className="px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800" data-id="element-445">
            Suspended
          </span>;
      default:
        return null;
    }
  };
  return <div className="bg-white rounded-lg shadow" data-id="element-446">
      {/* Header with actions */}
      <div className="p-6 border-b border-gray-200 flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0" data-id="element-447">
        <div className="flex items-center space-x-3" data-id="element-448">
          <div className="relative" data-id="element-449">
            <SearchIcon className="h-5 w-5 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2" data-id="element-450" />
            <input type="text" placeholder="Search users..." className="pl-10 pr-4 py-2 border rounded-md focus:ring-[#006D77] focus:border-[#006D77] w-full sm:w-64" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-451" />
          </div>
          <div className="relative" data-id="element-452">
            <FilterIcon className="h-5 w-5 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2" data-id="element-453" />
            <select className="pl-10 pr-4 py-2 border rounded-md focus:ring-[#006D77] focus:border-[#006D77] appearance-none bg-white" value={filterStatus} onChange={e => setFilterStatus(e.target.value)} data-id="element-454">
              <option value="all" data-id="element-455">All Status</option>
              <option value="active" data-id="element-456">Active</option>
              <option value="inactive" data-id="element-457">Inactive</option>
              <option value="suspended" data-id="element-458">Suspended</option>
            </select>
          </div>
        </div>
      </div>
      {/* User list */}
      <div className="overflow-x-auto" data-id="element-459">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-460">
          <thead className="bg-gray-50" data-id="element-461">
            <tr data-id="element-462">
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-463">
                User
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-464">
                Contact
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-465">
                Joined
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-466">
                Status
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-467">
                Bookings
              </th>
              <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-468">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-469">
            {filteredUsers.map(user => <tr key={user.id} className="hover:bg-gray-50" data-id="element-470">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-471">
                  <div className="flex items-center" data-id="element-472">
                    <div className="h-10 w-10 rounded-full overflow-hidden flex-shrink-0" data-id="element-473">
                      <img src={user.avatar} alt={user.name} className="h-full w-full object-cover" data-id="element-474" />
                    </div>
                    <div className="ml-4" data-id="element-475">
                      <div className="text-sm font-medium text-gray-900" data-id="element-476">
                        {user.name}
                      </div>
                      <div className="text-sm text-gray-500" data-id="element-477">ID: {user.id}</div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4" data-id="element-478">
                  <div className="flex flex-col" data-id="element-479">
                    <div className="flex items-center text-sm text-gray-500" data-id="element-480">
                      <MailIcon className="h-4 w-4 mr-1" data-id="element-481" />
                      {user.email}
                    </div>
                    <div className="flex items-center text-sm text-gray-500 mt-1" data-id="element-482">
                      <PhoneIcon className="h-4 w-4 mr-1" data-id="element-483" />
                      {user.phone}
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-484">
                  <div className="flex items-center text-sm text-gray-500" data-id="element-485">
                    <CalendarIcon className="h-4 w-4 mr-1" data-id="element-486" />
                    {user.dateJoined}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-487">
                  {getStatusBadge(user.status)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-488">
                  {user.bookings}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-489">
                  {user.status === 'suspended' ? <button className="text-green-500 hover:text-green-700 mr-3" data-id="element-490">
                      <CheckCircleIcon className="h-5 w-5" data-id="element-491" />
                    </button> : user.status === 'active' ? <button className="text-red-500 hover:text-red-700 mr-3" data-id="element-492">
                      <XCircleIcon className="h-5 w-5" data-id="element-493" />
                    </button> : <button className="text-green-500 hover:text-green-700 mr-3" data-id="element-494">
                      <CheckCircleIcon className="h-5 w-5" data-id="element-495" />
                    </button>}
                  <button className="text-blue-500 hover:text-blue-700" data-id="element-496">
                    View
                  </button>
                </td>
              </tr>)}
          </tbody>
        </table>
        {filteredUsers.length === 0 && <div className="text-center py-10" data-id="element-497">
            <p className="text-gray-500" data-id="element-498">
              No users found matching your criteria
            </p>
          </div>}
      </div>
      {/* Pagination */}
      <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between" data-id="element-499">
        <div className="text-sm text-gray-500" data-id="element-500">
          Showing <span className="font-medium" data-id="element-501">{filteredUsers.length}</span> of{' '}
          <span className="font-medium" data-id="element-502">{users.length}</span> users
        </div>
        <div className="flex items-center space-x-2" data-id="element-503">
          <button className="px-3 py-1 border rounded text-sm disabled:opacity-50" data-id="element-504">
            Previous
          </button>
          <button className="px-3 py-1 bg-[#006D77] text-white rounded text-sm" data-id="element-505">
            1
          </button>
          <button className="px-3 py-1 border rounded text-sm" data-id="element-506">Next</button>
        </div>
      </div>
    </div>;
};
export default AdminUserList;